<div fxLayout.xs="column" fxLayoutAlign="start center">
    <button [attr.guide]="'excel-productsize-chart-btn-1' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="addColumn()">Add Column to start</button>
    <button [attr.guide]="'excel-productsize-chart-btn-2' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="add_Column()">Add Column to end</button>
    <button [attr.guide]="'excel-productsize-chart-btn-3' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="removeColumn()">Remove Column</button>
    <button [attr.guide]="'excel-productsize-chart-btn-4' + '__' + sanitizeUrl(url)" mat-raised-button (click)="insertTop()">Add row on top</button>
    <button [attr.guide]="'excel-productsize-chart-btn-5' + '__' + sanitizeUrl(url)" mat-raised-button (click)="insertBottom()">Add row on bottom</button>
    <!-- <button [attr.guide]="'excel-productsize-chart-btn-6' + '__' + sanitizeUrl(url)" mat-raised-button (click)="saveAll()">Save All</button> -->
</div>
<table class="size-chart-table">
    <tr>
        <th *ngFor="let header of tableHeaders">{{ header }}</th>
        <th *ngIf="tableHeaders.length>0">Actions</th>
      </tr>
      <tr *ngFor="let row of tabledata; let rowIndex = index">
        <ng-container *ngIf="!row.editing; else editMode">
          <td *ngFor="let header of tableHeaders">{{ row[header] }}</td>
          <td *ngIf="tableHeaders.length>0">
            <button [attr.guide]="'excel-productsize-chart-btn-7' + '__' + sanitizeUrl(url)" mat-raised-button (click)="editRow(rowIndex)">Edit</button>
            <button [attr.guide]="'excel-productsize-chart-btn-8' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="delete(rowIndex)">Delete</button>
        </td>
        </ng-container>
        <ng-template #editMode>
          <td *ngFor="let header of tableHeaders">
            <!-- <mat-form-field appearance="outline" fxFlex> -->
            <input [attr.guide]="'excel-productsize-chart-inp-9' + '__' + sanitizeUrl(url)" [(ngModel)]="row[header]" class="inputcss"/>
            <!-- </mat-form-field> -->
          </td>
          <td *ngIf="tableHeaders.length>0">
            <button [attr.guide]="'excel-productsize-chart-btn-10' + '__' + sanitizeUrl(url)" mat-raised-button (click)="saveRow(rowIndex)">Save</button>
            <button [attr.guide]="'excel-productsize-chart-btn-11' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="cancelEdit(rowIndex)">Cancel</button>
          </td>
        </ng-template>
      </tr>
   </table>